<div class="">
  <div class="text-center">
    <h4 style="padding: 1em; font-weight: bold">Remove Hard Drives</h4>
  </div>
</div>

<div class="pt-0 pb-4 px-4">
  <div>
    <hr class="divider" />
    <ngx-skeleton-loader
      *ngIf="loading"
      count="10"
      appearance="line"
      animation="pulse"
    ></ngx-skeleton-loader>
    <dinamic-table
      *ngIf="!loading"
      [id]="'removeHardDrivesTable'"
      [dbname]="'hddsearchtable'"
      [data]="multipleData"
      [bulk]="bulk"
      [checkAllGrayed]="true"
      (changeBulk)="checkBulk($event)"
      (buscar)="List($event)"
      [columnfilters]="filtros"
      (rightClickAction)="handleRightClick($event)"
      [perPage]="itemsPorPagina"
      [page]="paginaActual"
      [total_items_count]="totalItems"
      [total_pages]="totalPaginas"
    ></dinamic-table>
    <hr class="divider" />
  </div>

  <div class="justify-content-between d-flex">
    <app-button-primary
      (clickBtn)="close()"
      [outline]="true"
      iconLeft="cancel"
      label="Close"
    >
    </app-button-primary>
    <app-button-primary
      *ngIf="statusRemoveHardDrive !== 'REMOVED'"
      (clickBtn)="openModalRemove()"
      [primary]="true"
      iconLeft="backspace"
      [disabled]="this.bulk.length === 0"
      [label]="'Remove Hard Drives' + ' ' + '(' + bulk.length + ')'"
    >
    </app-button-primary>
    <app-button-primary
      (clickBtn)="openModalReturn()"
      [disabled]="this.bulk.length === 0"
      *ngIf="statusRemoveHardDrive === 'REMOVED'"
      iconLeft="replay"
      [warning]="true"
      [label]="'Return Hard Drives' + ' ' + '(' + bulk.length + ')'"
    >
    </app-button-primary>
    <!-- <button
      (click)="openModalReturn()"
      class="btn btn-warning btn-md"
      [disabled]="this.bulk.length === 0"
      *ngIf="statusRemoveHardDrive === 'REMOVED'"
    >
      <i class="fa fa-reply" aria-hidden="true"></i> &nbsp; Return Hard Drives
      ({{ bulk.length }})
    </button> -->
  </div>
</div>

<div
  class="modal fade"
  id="modalPartial"
  tabindex="-1"
  role="dialog"
  data-backdrop="static"
  aria-labelledby="exampleModalScrollableTitle"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-scrollable modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="exampleModalScrollableTitle">
          Save Changes
        </h4>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p>
          <strong>This drive needs to be physically destroyed!</strong>
        </p>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-success"
          (click)="removeHardDrives(1)"
        >
          Accept
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="modalCheckReport"
  tabindex="-1"
  role="dialog"
  data-backdrop="static"
  aria-labelledby="exampleModalScrollableTitle"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-scrollable modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="exampleModalScrollableTitle">
          Physical Destruction Report
        </h4>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p>
          <strong>Choose the report</strong>
        </p>
      </div>
      <div class="modal-footer">
        <!--<button type="button" class="btn btn-success" (click)="checkReport('basic')">Basic</button>
            &nbsp; &nbsp;
            <button type="button" class="btn btn-success" (click)="checkReport('detail')">Detailed</button>-->
      </div>
    </div>
  </div>
</div>
